var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("entity-reader", {
    attrs: {
      entity: "lammie",
      id: _vm.id,
      "use-sharing": false,
      "api-name": "lammieRequests"
    },
    scopedSlots: _vm._u(
      [
        {
          key: `reader`,
          fn: function({ doc }) {
            return [
              _c("label-value", { attrs: { name: "Name", value: doc.name } }),
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { cols: "12", sm: "2" } }, [
                    _c("span", { staticClass: "font-weight-medium" }, [
                      _vm._v("Plot")
                    ])
                  ]),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "10" } },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              name: "readPlot",
                              params: { id: doc.plotKeyId }
                            },
                            title: doc.plotName
                          }
                        },
                        [_vm._v(" " + _vm._s(doc.plotName) + " ")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("label-value", {
                attrs: {
                  name: "Event Needed",
                  value: _vm.getEventName(doc.eventId)
                }
              }),
              _c("label-value", {
                attrs: { name: "Year Required", value: doc.yearRequired }
              }),
              _c("label-value", {
                attrs: { name: "Duration", value: doc.requiredDuration }
              }),
              _c("label-value", {
                attrs: { name: "Reprint", value: doc.isReprint }
              }),
              _c("label-value", {
                attrs: { name: "Phys Rep", value: doc.physRep }
              }),
              _c("label-value", {
                attrs: { name: "Purpose", value: doc.intendedPurpose }
              }),
              _c("label-value", {
                attrs: { name: "Powers", value: doc.powers }
              }),
              _c("label-value", { attrs: { name: "Notes", value: doc.notes } }),
              _c("label-value", {
                attrs: { name: "Lore Codes", value: doc.loreCodes }
              })
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }